import { Refresh } from '@mui/icons-material';
import { Button, CircularProgress, Tooltip } from '@mui/material';

interface PBIRefreshButtonProps {
  onclick_action: (() => Promise<void>) | null;
  is_refreshing: boolean;
}

const PBIRefreshButton = ({ onclick_action, is_refreshing }: PBIRefreshButtonProps) => {
  return (
    <Tooltip title="Refresh dashboard">
      <Button
        onClick={onclick_action ? () => onclick_action() : undefined}
        disabled={is_refreshing || !onclick_action}
        sx={{
          color: '#006a77',
          backgroundColor: '#fff',
          border: is_refreshing ? 'none' : '1px solid #006a77'
        }}
      >
        {is_refreshing ? <CircularProgress size={25} /> : <Refresh />}
      </Button>
    </Tooltip>
  );
};

export default PBIRefreshButton;
